export default "__VITE_ASSET__Dp_c9GNO__"